export enum Error {
  general = "submit.err.general",
  medicineNotFound = "submit.err.medicineNotFound",
  medicineNotValidCode = "submit.err.medicineNotValidCode",
  sign = "submit.err.sign",
  submit = "submit.err.submit",
  upload = "submit.err.upload",
  notRegState = "submit.err.notRegState"
}

export enum Success {
  submit = "submit.msg.submit",
  edit = "submit.msg.edit",
  sign = "submit.msg.sign"
}
